import {
    MdCalendarViewMonth,
    MdChevronLeft,
    MdChevronRight,
    MdToday,
    MdViewDay,
    MdViewWeek,
} from 'react-icons/md'
import { CalendarView } from '../../utils/calendar-utils'

interface CalendarHeaderProps {
    title: string
    view: CalendarView
    onPrevious: () => void
    onNext: () => void
    onToday: () => void
    onViewChange: (view: CalendarView) => void
}

export function CalendarHeader({
    title,
    view,
    onPrevious,
    onNext,
    onToday,
    onViewChange,
}: CalendarHeaderProps) {
    return (
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-4">
            <div className="flex items-center gap-2">
                <button
                    className="btn btn-ghost btn-sm btn-square"
                    onClick={onPrevious}
                    aria-label="Anterior"
                >
                    <MdChevronLeft className="text-xl" />
                </button>
                <button
                    className="btn btn-ghost btn-sm btn-square"
                    onClick={onNext}
                    aria-label="Proximo"
                >
                    <MdChevronRight className="text-xl" />
                </button>
                <button
                    className="btn btn-ghost btn-sm"
                    onClick={onToday}
                >
                    <MdToday className="text-lg" />
                    <span className="hidden sm:inline">Hoje</span>
                </button>
                <h2 className="text-lg sm:text-xl font-semibold text-base-content capitalize ml-2">
                    {title}
                </h2>
            </div>

            <div className="flex items-center gap-1 bg-base-200 rounded-lg p-1">
                <button
                    className={`btn btn-sm ${view === 'day'
                            ? 'btn-secondary'
                            : 'btn-ghost'
                        }`}
                    onClick={() => onViewChange('day')}
                >
                    <MdViewDay className="text-lg" />
                    <span className="hidden sm:inline">Dia</span>
                </button>
                <button
                    className={`btn btn-sm ${view === 'week'
                            ? 'btn-secondary'
                            : 'btn-ghost'
                        }`}
                    onClick={() => onViewChange('week')}
                >
                    <MdViewWeek className="text-lg" />
                    <span className="hidden sm:inline">Semana</span>
                </button>
                <button
                    className={`btn btn-sm ${view === 'month'
                            ? 'btn-secondary'
                            : 'btn-ghost'
                        }`}
                    onClick={() => onViewChange('month')}
                >
                    <MdCalendarViewMonth className="text-lg" />
                    <span className="hidden sm:inline">Mês</span>
                </button>
            </div>
        </div>
    )
}
